import { createContext, createElement } from 'react'

import { useUserInfo } from './hooks/userinfo'
import { useSubLog } from './hooks/subLog'
import { useSubUsage } from './hooks/subUsage'
import { ProductsSubAppName } from './types'
import { useCreatorInfo } from './hooks/creatorInfo'

import type { $Enums } from '@prisma/client'


import { useContext } from 'react';
export interface ISiteSpecificInitialValue {
  appName?: $Enums.SubLogAppName
}

export function useSiteSpecific(initialValue?: ISiteSpecificInitialValue) {
  const appName = initialValue?.appName || ProductsSubAppName.App1
  const user = useUserInfo()
  const creator = useCreatorInfo()
  const plan = useSubLog({ appName })
  const usage = useSubUsage({ appName })
  const { isPaidUser } = useSubLog({ appName })

  const clearSiteSpecificContext = () => {
    plan.remove()
    usage.remove()
    user.remove()
    creator.remove()
  }

  return {
    user,
    plan,
    usage,
    isPaidUser,
    appName,
    creator,
    clearSiteSpecificContext,
  }
}

const Context = createContext<ReturnType<typeof useSiteSpecific>>({
  user: {} as any,
  plan: {} as any,
  usage: {} as any,
  creator: {} as any,
  isPaidUser: false,
  appName: ProductsSubAppName.App1,
  clearSiteSpecificContext: () => {},
})

export function SiteSpecificContextProvider({
  children,
  initialValue,
}: {
  children: React.ReactNode
  initialValue?: ISiteSpecificInitialValue
}) {
  const value = useSiteSpecific(initialValue)
  return createElement(Context.Provider, { value }, children)
}

export const useSiteSpecificContext = () => {
  const context = useContext(Context)
  if (!context) {
    throw new Error(
      'useSiteSpecificContext must be used within a SiteSpecificContextProvider',
    )
  }
  return context
}
